/**
 * Basic authentication state enumeration
 */
export enum AuthenticationState {
    /** User is authenticated */
    AUTHENTICATED = 'authenticated',
    /** User is not authenticated */
    UNAUTHENTICATED = 'unauthenticated',
    /** Authentication state is being determined */
    LOADING = 'loading',
}

/**
 * Authentication method types
 */
export enum AuthenticationMethod {
    /** Password-based authentication */
    PASSWORD = 'password',
    /** OAuth-based authentication */
    OAUTH = 'oauth',
    /** Single Sign-On authentication */
    SSO = 'sso',
}

/**
 * Base authentication error interface
 */
export interface AuthError {
    /** Error message */
    message: string;
    /** Error code or type */
    code: string;
    /** Additional error context */
    context?: Record<string, any>;
}
